/* eslint-disable no-unused-vars */
export enum SortDirection {
    ASCENDING = 'asc',
    DESCENDING = 'desc'
}
